import { render, staticRenderFns } from "./ace-editor-css.vue?vue&type=template&id=e2db611e&"
import script from "./ace-editor-css.vue?vue&type=script&lang=js&"
export * from "./ace-editor-css.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2db611e')) {
      api.createRecord('e2db611e', component.options)
    } else {
      api.reload('e2db611e', component.options)
    }
    module.hot.accept("./ace-editor-css.vue?vue&type=template&id=e2db611e&", function () {
      api.rerender('e2db611e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/common/ace-editor-css.vue"
export default component.exports